export const getColorType = (colorVariable) => (colorVariable === 'transparent' ? 'color' : 'background');
